import { Button, ButtonProps, Tooltip, TooltipProps } from "antd";
import { ReactElement } from "react";

export interface IconButtonProps extends Omit<ButtonProps, "children" | "title" | "aria-label"> {
  icon: NonNullable<ButtonProps["icon"]>;
  title: string;
  tooltipProps?: Omit<TooltipProps, "title" | "children">;
}

export default function IconButton({ icon, title, tooltipProps, ...buttonProps }: IconButtonProps): ReactElement {
  return (
    <Tooltip title={title} {...tooltipProps}>
      <Button {...buttonProps} icon={icon} aria-label={title} />
    </Tooltip>
  );
}
